// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Restore Payment</h1>
        </div>
        <div class="hoa-dialog__main">
            <p>Are you sure you want to restore the payment scheduled on {{data.paymentDate}}
                for {{data.paymentAmount | currency}} ?</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="restorePaymentNoButton"
                    id="restorePaymentNoButton"
                    class="Button Button--link Button--minWidth130"
                    (click)="closeThisDialog(0)">
                No
            </button>
            <button tid="restorePaymentYesButton"
                    id="restorePaymentYesButton"
                    class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog('Restore')">
                Yes
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;